import { initialDaAndFleetState } from "store/initialStates";
import { DaAndFleetState } from "types/DaAndFleet";
import { ReducersInterfaceAction } from "types/Reducers";
import { DaAndFleetConstants } from "constants/constants";
import moment from "moment";

export const daAndFleetReducer = (
  state = initialDaAndFleetState,
  action: ReducersInterfaceAction,
): DaAndFleetState => {
  switch (action.type) {
    case DaAndFleetConstants.DA_FLEET_GET_ALL_DRIVERS_SUCCESS:
      return {
        ...state,
        loadingData: false,
        driverData: {
          ...state?.driverData,
          driverList: action.payload?.results,
          driverListCount: action.payload?.count,
        },
      };
    case DaAndFleetConstants.DA_FLEET_GET_ALL_FLEEETS_SUCCESS:
      return {
        ...state,
        loadingData: false,
        fleetData: {
          ...state?.fleetData,
          fleetList: action.payload?.results,
          fleetListCount: action.payload?.count,
        },
      };
    case DaAndFleetConstants.DA_FLEET_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case DaAndFleetConstants.DA_FLEET_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case DaAndFleetConstants.DA_UPDATE_SETTINGS:
      return {
        ...state,
        driverData: {
          ...state.driverData,
          driverListFilters: { ...state.driverData.driverListFilters, ...action.payload },
        },
      };
    case DaAndFleetConstants.FLEET_UPDATE_SETTINGS:
      return {
        ...state,
        fleetData: {
          ...state.fleetData,
          fleetListFilters: { ...state.fleetData.fleetListFilters, ...action.payload },
        },
      };
    case DaAndFleetConstants.DA_FLEET_INITIALIZE_LABEL_DATE_TYPE:
      return {
        ...state,
        driverData: {
          ...state.driverData,
          driverListFilters: {
            ...state.driverData.driverListFilters,
            stations: [],
            statuses: [1, 3, 5, 6],
            selectType: "date",
            dateFilters: {
              date: moment().format("yyyy-MM-DD"),
              week: `${moment().format("yyyy")}-W${moment().format("W")}`,
              month: `${moment().format("yyyy")}-${moment().format("MM")}`,
              year: moment().format("yyyy"),
            },
          },
        },
        fleetData: {
          ...state.fleetData,
          fleetListFilters: {
            ...state.fleetData.fleetListFilters,
            stations: [],
            statuses: [1, 2, 3],
            selectType: "date",
            dateFilters: {
              date: moment().format("yyyy-MM-DD"),
              week: `${moment().format("yyyy")}-W${moment().format("W")}`,
              month: `${moment().format("yyyy")}-${moment().format("MM")}`,
              year: moment().format("yyyy"),
            },
          },
        },
      };
    case DaAndFleetConstants.DA_FEET_SET_FLEET_ID_LIST:
      return {
        ...state,
        fleetData: {
          ...state?.fleetData,
          idListForUpdate: action.payload,
        },
      };
    case DaAndFleetConstants.DA_FEET_SET_DA_ID_LIST:
      return {
        ...state,
        driverData: {
          ...state?.driverData,
          idListForUpdate: action.payload,
        },
      };
    case DaAndFleetConstants.UPDATE_DA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        driverData: {
          ...state?.driverData,
          driverList: action.payload,
          idListForUpdate: [],
        },
      };
    case DaAndFleetConstants.UPDATE_FLEET_SUCCESS:
      return {
        ...state,
        loadingData: false,
        fleetData: {
          ...state?.fleetData,
          fleetList: action.payload,
          idListForUpdate: [],
        },
      };
    default:
      return state;
  }
};
